// extracted by mini-css-extract-plugin
export default {"wrap":"vinQsysc_csewlRlcfNq","row":"uVd7hstHu7Az2SzrpZtz","labelCol":"diLzk_i22abQ2JOfaX_1","inputCol":"vwvjQVVzc_Xnh9uH8PIm"};